{
    "m3WorkflowBuilder": {
        "title": "M3 Workflow Builder",
        "subtitle": "Select program and transaction to view metadata",
        "connection": "Connection",
        "connectionPlaceholder": "Select a connection...",
        "program": "Program",
        "programPlaceholder": "Search and select a program...",
        "programCount": "{count} programs",
        "transaction": "Transaction",
        "transactionPlaceholder": "Search and select a transaction...",
        "inputFields": "Input Fields",
        "outputFields": "Output Fields",
        "fieldCount": "{count} fields",
        "fieldName": "Name",
        "fieldDescription": "Description",
        "fieldType": "Type",
        "fieldLength": "Length",
        "fieldMandatory": "Mandatory",
        "required": "Required",
        "noInputFields": "No input fields",
        "noOutputFields": "No output fields",
        "createWorkflow": "Create Workflow",
        "workflowName": "Workflow Name",
        "workflowNamePlaceholder": "Enter workflow name",
        "create": "Create",
        "creating": "Creating...",
        "workflowCreated": "Created",
        "workflowCreatedSuccess": "Workflow created successfully!",
        "workflowId": "Workflow ID",
        "workflowCreateFailed": "Failed to create workflow",
        "runWorkflow": "Run Workflow",
        "runInfo": "For a workflow to be used in the App Builder, it needs to have been triggered at least once. Please do so below.",
        "run": "Run Workflow",
        "running": "Running...",
        "workflowResult": "Workflow Result",
        "recordCount": "{count} record(s)",
        "noRecords": "No records returned",
        "error": "Error",
        "field": "Field",
        "loadConnectionsError": "Failed to load connections",
        "loadProgramsError": "Failed to load programs",
        "loadTransactionsError": "Failed to load transactions",
        "loadFieldsError": "Failed to load transaction fields",
        "createWorkflowError": "Failed to create workflow",
        "runWorkflowError": "Failed to run workflow",
        "menuLabel": "M3 Workflow Builder"
    }
}
